import { SectionItem } from 'src/types'

export const getYearFoundedYear = (yearFounded: number) => {
  return yearFounded
}

export const getYearFoundedItem = (title: string = 'YEAR FOUNDED', yearFounded?: number | null) => {
  if (!yearFounded) {
    return null
  }

  const year = getYearFoundedYear(yearFounded)
  if (!year) {
    return null
  }

  const yearFoundedItem: SectionItem = {
    title,
    type: 'SpanDataList',
    subType: 'more',
    items: [{ name: yearFounded }],
  }

  return yearFoundedItem
}
